import { render, staticRenderFns } from "./SelfWrapper.vue?vue&type=template&id=7c1a06a2&"
import script from "./SelfWrapper.vue?vue&type=script&lang=js&"
export * from "./SelfWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports